import { useMemo } from "react";
import { parseISO } from "../../utils";

const useTemporaryContent = (times) => {
  const { startIn, stopIn } = { startIn: new Date(), ...times };

  const startDate = useMemo(() => parseISO(startIn) || new Date(), [startIn]);
  const stopDate = useMemo(() => parseISO(stopIn) || null, [stopIn]);
  const show = useMemo(() => {
    const currentDate = new Date();

    return stopDate && currentDate <= stopDate && currentDate >= startDate;
  }, [startDate, stopDate]);

  return { show, startDate, stopDate };
};

export default useTemporaryContent;
